module.exports = __webpack_public_path__ + "static/img/aboutUs.204eefa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs.png
// module id = BbTC
// module chunks = 1